// Versioned, restricted HTML in the existing text fields. Legacy text is never
// interpreted as HTML. Only locally reconstructed, allowlisted nodes are rendered.
export const RICH_PREFIX = "[rich:1]";
const escape = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

export function cleanAnnouncementHtml(html) {
  const doc = new DOMParser().parseFromString(html, "text/html");
  function walk(node) {
    if (node.nodeType === 3) return escape(node.textContent);
    if (node.nodeType !== 1) return "";
    const tag = node.tagName.toLowerCase();
    if (["script", "style", "iframe", "object", "svg", "math"].includes(tag)) return "";
    if (tag === "br") return "<br>";
    let content = Array.from(node.childNodes, walk).join("");
    if (["b", "strong"].includes(tag)) content = `<b>${content}</b>`;
    if (["i", "em"].includes(tag)) content = `<i>${content}</i>`;
    if (tag === "u") content = `<u>${content}</u>`;
    const color = node.getAttribute("color") || node.style.color;
    if (/^(#[0-9a-f]{6}|rgb\(\d{1,3}, ?\d{1,3}, ?\d{1,3}\))$/i.test(color || "")) content = `<font color="${color}">${content}</font>`;
    const size = node.getAttribute("size");
    if (/^[2-5]$/.test(size || "")) content = `<font size="${size}">${content}</font>`;
    if (["div", "p"].includes(tag)) {
      const previous = node.previousSibling;
      if (previous && !["DIV", "P", "BR"].includes(previous.nodeName)) content = "<br>" + content;
      content += "<br>";
    }
    return content;
  }
  return Array.from(doc.body.childNodes, walk).join("").replace(/(<br>)+$/, "");
}

export function announcementHtml(value = "") {
  return value.startsWith(RICH_PREFIX)
    ? cleanAnnouncementHtml(value.slice(RICH_PREFIX.length))
    : escape(value).replace(/\n/g, "<br>");
}

export function announcementPlainText(value = "") {
  const doc = new DOMParser().parseFromString(announcementHtml(value).replace(/<br>/g, "\n"), "text/html");
  return doc.body.textContent || "";
}

export function encodeAnnouncement(html) {
  const clean = cleanAnnouncementHtml(html);
  const plain = announcementPlainText(RICH_PREFIX + clean);
  if (!plain.trim()) return "";
  return /<(b|i|u|font)[ >]/.test(clean) ? RICH_PREFIX + clean : plain;
}
